import { Component, inject, computed, ChangeDetectionStrategy, Signal } from '@angular/core';
import { StepComponent } from './step.component';

@Component({
  selector: 'td-wb-step-title',
  template: '<ng-content />',
  styleUrls: ['./step-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.td-wb-step-title--active]': 'isActive()',
    '[attr.id]': 'id()',
    '[attr.aria-hidden]': 'ariaHidden()'
  }
})
export class StepTitleComponent {
  private stepComponent: StepComponent = inject(StepComponent);

  isActive: Signal<boolean> = computed(() => {
    return this.stepComponent.isLinear() &&
      (this.stepComponent.isActive() || this.stepComponent.isComplete());
  });

  id: Signal<string> = computed(() => this.stepComponent.getStepTitleId());

  ariaHidden: Signal<boolean> = computed(() => {
    return this.stepComponent.isLinear() || !this.stepComponent.isActive();
  });
}
